import React from "react";

export default function ColorFrame47({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          stroke="#713A46"
          strokeLinecap="round"
          strokeWidth="4.409"
          d="M126.687 96V49.274c0-16.397 5.871-43.912 30.066-45.591 24.196-1.68 41.718 30.76 33.889 77.886"
        ></path>
        <path
          fill="#F7E7CF"
          d="M28.5 260.95S48.782 112.359 54.514 61.653c0 0 26.986 7.347 76.986 7.347s81-7.347 81-7.347l24 199.297c-32.629 0-205.355.441-208 0z"
        ></path>
        <circle
          cx="91.993"
          cy="81.053"
          r="5.732"
          stroke="#713A46"
          strokeWidth="1.764"
        ></circle>
        <circle
          cx="169.595"
          cy="84.581"
          r="5.732"
          stroke="#713A46"
          strokeWidth="1.764"
        ></circle>
        <circle
          cx="91.993"
          cy="81.053"
          r="2.205"
          stroke="#713A46"
          strokeWidth="1.764"
        ></circle>
        <circle
          cx="169.595"
          cy="84.581"
          r="2.205"
          stroke="#713A46"
          strokeWidth="1.764"
        ></circle>
        <path
          stroke="#944C5B"
          strokeLinecap="round"
          strokeWidth="4.409"
          d="M169.581 84.127c6.091-29.524-7.922-83.765-40.107-81.682C97.29 4.527 87.544 57.2 91.961 81.33"
        ></path>
        <rect
          width="104.072"
          height="104.072"
          x="80.464"
          y="135.464"
          fill="#fff"
          stroke="#944C5B"
          strokeWidth="8.928"
          rx="11.606"
        ></rect>
        <path
          fill="#713A46"
          d="M83.4 117.2c-.92 0-1.753-.107-2.5-.32a6.729 6.729 0 01-1.96-.96 8.216 8.216 0 01-1.54-1.5l2.06-2.34c.667.893 1.333 1.493 2 1.8.68.307 1.38.46 2.1.46.36 0 .687-.047.98-.14.293-.093.52-.227.68-.4.16-.187.24-.413.24-.68 0-.2-.053-.38-.16-.54-.093-.16-.227-.3-.4-.42a2.976 2.976 0 00-.62-.32 4.634 4.634 0 00-.76-.26 8.087 8.087 0 00-.82-.2 10.939 10.939 0 01-2.02-.64 5.132 5.132 0 01-1.44-.92 3.724 3.724 0 01-.84-1.26 4.38 4.38 0 01-.28-1.6c0-.627.14-1.2.42-1.72.293-.533.68-.987 1.16-1.36a5.273 5.273 0 011.7-.88 6.292 6.292 0 012-.32c.92 0 1.707.1 2.36.3.667.187 1.233.46 1.7.82.48.36.887.793 1.22 1.3l-2.1 2.02a4.282 4.282 0 00-.92-.86c-.32-.227-.667-.4-1.04-.52-.36-.12-.733-.18-1.12-.18-.4 0-.747.053-1.04.16-.28.093-.5.233-.66.42a.908.908 0 00-.24.64c0 .227.067.42.2.58.133.16.313.307.54.44.227.12.487.227.78.32.293.08.6.147.92.2.733.147 1.393.34 1.98.58.6.24 1.113.533 1.54.88.44.347.773.76 1 1.24.24.467.36 1.013.36 1.64 0 .973-.24 1.8-.72 2.48-.467.667-1.113 1.18-1.94 1.54-.813.347-1.753.52-2.82.52zm7.696-.2v-14.8h3.14v6.34l-.64.24c.146-.48.406-.913.78-1.3.386-.4.846-.72 1.38-.96a4.048 4.048 0 011.68-.36c.8 0 1.473.167 2.02.5.546.32.96.807 1.24 1.46.28.64.42 1.427.42 2.36V117h-3.22v-6.26c0-.427-.06-.78-.18-1.06a1.215 1.215 0 00-.56-.62c-.24-.147-.54-.213-.9-.2-.28 0-.54.047-.78.14-.24.08-.447.207-.62.38-.174.16-.314.347-.42.56-.094.213-.14.447-.14.7V117h-3.2zm17.695.2c-1.107 0-2.093-.24-2.96-.72a5.537 5.537 0 01-2.04-1.96c-.493-.827-.74-1.773-.74-2.84s.247-2.013.74-2.84a5.537 5.537 0 012.04-1.96c.867-.48 1.853-.72 2.96-.72s2.087.24 2.94.72a5.333 5.333 0 012.04 1.96c.493.827.74 1.773.74 2.84s-.247 2.013-.74 2.84a5.333 5.333 0 01-2.04 1.96c-.853.48-1.833.72-2.94.72zm0-2.76c.48 0 .907-.12 1.28-.36s.667-.567.88-.98c.213-.413.313-.887.3-1.42.013-.533-.087-1.007-.3-1.42a2.472 2.472 0 00-.88-1c-.373-.24-.8-.36-1.28-.36s-.913.12-1.3.36c-.373.24-.667.573-.88 1-.213.413-.313.887-.3 1.42-.013.533.087 1.007.3 1.42.213.413.507.74.88.98.387.24.82.36 1.3.36zm7.813 6.96v-15.02h3.04l.12 2.38-.6-.18c.093-.44.32-.84.68-1.2.36-.36.813-.647 1.36-.86a4.638 4.638 0 011.76-.34c.906 0 1.713.24 2.42.72.706.467 1.26 1.113 1.66 1.94.413.813.62 1.76.62 2.84 0 1.067-.207 2.013-.62 2.84-.4.827-.96 1.48-1.68 1.96-.707.467-1.52.7-2.44.7-.6 0-1.174-.113-1.72-.34a4.033 4.033 0 01-1.38-.92c-.374-.387-.62-.807-.74-1.26l.74-.28v7.02h-3.22zm5.54-6.92c.48 0 .9-.113 1.26-.34.36-.24.64-.567.84-.98.2-.413.3-.907.3-1.48 0-.56-.1-1.047-.3-1.46-.2-.427-.48-.753-.84-.98-.347-.24-.767-.36-1.26-.36-.494 0-.92.113-1.28.34-.36.227-.64.553-.84.98-.2.427-.3.92-.3 1.48 0 .573.1 1.067.3 1.48.2.413.48.74.84.98.36.227.786.34 1.28.34zm14.389 2.52v-14h3.04l7.34 10-.66-.1c-.066-.44-.12-.86-.16-1.26l-.12-1.18-.08-1.18-.04-1.3V103h3.3v14h-3.08l-7.66-10.32 1.02.14c.067.64.12 1.187.16 1.64.054.44.094.833.12 1.18a13.942 13.942 0 01.1 1.78c.014.267.02.567.02.9V117h-3.3zm20.793.2c-1.106 0-2.093-.24-2.96-.72a5.537 5.537 0 01-2.04-1.96c-.493-.827-.74-1.773-.74-2.84s.247-2.013.74-2.84a5.537 5.537 0 012.04-1.96c.867-.48 1.854-.72 2.96-.72 1.107 0 2.087.24 2.94.72a5.333 5.333 0 012.04 1.96c.494.827.74 1.773.74 2.84s-.246 2.013-.74 2.84a5.333 5.333 0 01-2.04 1.96c-.853.48-1.833.72-2.94.72zm0-2.76c.48 0 .907-.12 1.28-.36a2.5 2.5 0 00.88-.98c.214-.413.314-.887.3-1.42.014-.533-.086-1.007-.3-1.42a2.465 2.465 0 00-.88-1c-.373-.24-.8-.36-1.28-.36s-.913.12-1.3.36a2.48 2.48 0 00-.88 1c-.213.413-.313.887-.3 1.42-.013.533.087 1.007.3 1.42.214.413.507.74.88.98.387.24.82.36 1.3.36zm9.742 2.56l-3.5-10.62h3.38l1.96 6.9-.42-.08 2.2-5.36h1.88l2.32 5.38-.46.04 1.96-6.88h3.38l-3.62 10.62h-2.36l-2.3-5.7.24.04-2.3 5.66h-2.36zm15.02-5.1c-.107-.813-.214-1.653-.32-2.52a56.907 56.907 0 01-.26-2.58 31.44 31.44 0 01-.1-2.46v-1.56h3.38v1.56c0 .8-.034 1.633-.1 2.5a58.654 58.654 0 01-.26 2.6 93.78 93.78 0 01-.34 2.46h-2zm1 5.32c-.547 0-.974-.153-1.28-.46-.307-.307-.46-.747-.46-1.32 0-.533.16-.967.48-1.3.32-.333.74-.5 1.26-.5.546 0 .966.16 1.26.48.306.307.46.747.46 1.32 0 .52-.16.947-.48 1.28-.32.333-.734.5-1.24.5z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
